import { Injectable } from '@angular/core';
import { Menu } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private menuList: Menu[];

  setMenus(menuList: Menu[]): void {
    this.menuList = menuList;
  }

  getMenusByPath(path: string): Menu {
    return this.menuList?.find((menu) => menu.path === path);
  }

  getMenus(): Menu[] {
    return this.menuList;
  }
}
